/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'SupplementCert',
    path: '/supplement-cert/index',
    component: () =>
      import(
        /* webpackChunkName: "SupplementCert" */ '@/views/supplement-cert/index'
      ),
    meta: { title: '上传网约车证' },
  },
];
